export const REGISTER_BOOK_CONSTANT = {
  REGISTER_BOOK_DATA: "/register-book",
  REGISTER_BOOK_TAB_DATA: "/register-book/list",
  REGISTER_BOOK_CREATE: "/register-book/create",
  ASSEMBLIES_LIST: "/common/assemblies",
  GAON_LIST: "/common/gaon",
  GATNO_LIST: "/common/gat",
  GAN_NUMBER_LIST: "/common/ganData",
  REGISTER_BOOK_ASSEMBLY:
    "?join=assembly&join=gat_number&join=gan_number&join=gaon",
  REGISTER_BOOK_LIST: "/register-book/list",
  REGISTER_BOOK_LETTERTYPE: "/letter-types",
  SEND_SMS: "/notification/initSMS",
  TOTAL_COUNT: "/register-book/total/count",
  DEPARTMENT: "/department",
  SUB_LETTER_TYPES:
    "/template-Mapping?join=letter&join=header&join=content&join=footer",
  CREATE_DOCUMENTS: "/create-documents",
  DOCUMENTS_LIST: "/create-documents/print/register-book",
  CREATED_DOCUMENTS_LIST: "/create-documents/register-book",
  WORK_STATUS: "/register-book/update/status",
  CAST: "/cast",
  FILE_IMAGE_TYPES:
    ".jpg,.jpeg,.png,.gif,.tiff,.psd,.pdf,.eps,.ai,.indd,.raw,.bmp,'.pptx',.pptm,.ppt,.xps,.potx,.potm,.pot,.thmx,.ppsx,.pps,.ppam,.ppa,.odp,.doc,.txt,.dot,.wbk,.docx,.docm,.dotx,.dotm,.docb,.odt,.xls,.xlt,.xlm,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xla,.xlam,.xll,xlw,.ods",
  EXCEL_DOWNLOAD:"/register-book/export",
  REGISTER_ADD_COMMENT: "/common/comment",
  SYSTEM_CONFIG:"/system-manager/config"
};

export const EXCEL_FILE_DATA = {
  COLUMN_DEFINATION: [
    {
      isObj: false,
      displayName: "Id",
      valueKey: ["id"],
    },
    {
      isObj: false,
      displayName: "Token Number",
      valueKey: ["tokenNumber"],
    },
    {
      isObj: false,
      displayName: "Entry Type",
      valueKey: ["entryType"],
      type: "CUSTOM_STRING",
    },
    {
      isObj: false,
      displayName: "File Number",
      valueKey: ["file_number"],
    },
    {
      isObj: true,
      displayName: "Letter Type",
      obj: "letterType",
      valueKey: ["name"],
    },
    {
      isObj: false,
      displayName: "Latest Date",
      valueKey: ["updatedDate"],
      type: "DATE",
    },
    {
      isObj: true,
      displayName: "Receieve By",
      obj: "documentFor",
      valueKey: ["firstName", "middleName", "lastName"],
    },
    {
      isObj: true,
      displayName: "Document For",
      obj: "documentFor",
      valueKey: ["firstName", "middleName", "lastName"],
    },
    {
      isObj: true,
      displayName: "Assembly",
      obj: "assembly",
      valueKey: ["name"],
    },
    {
      isObj: false,
      displayName: "City Type",
      valueKey: ["cityType"],
      type: "CUSTOM_STRING",
    },
    {
      isObj: true,
      displayName: "Gat",
      obj: "gat_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gan",
      obj: "gan_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gaon",
      obj: "gaon",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Prabhag",
      obj: "prabhag",
      valueKey: ["name"],
    },
    {
      isObj: false,
      displayName: "Note",
      valueKey: ["comments"],
    },
  ],
};
